import { render, staticRenderFns } from "./FormInputSelectWidget.vue?vue&type=template&id=bb53a4a8&"
import script from "./FormInputSelectWidget.vue?vue&type=script&lang=js&"
export * from "./FormInputSelectWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports